import React from "react";

const WeekDayHeader = ({
  currentDay,
  day,
  index,
}) => {

  const formattedDate =
    currentDay
      .toLocaleDateString(
        "sv-SE",
        {
          day: "numeric",
          month: "long",
        }
      );

  const isToday =
    currentDay.toDateString() ===
    new Date().toDateString();

  return (
    <div
      className={`
        week-day-header
        ${isToday ? "today" : ""}
        ${index === 5 || index === 6
          ? "weekend"
          : ""}
      `}
    >
      <span className="day-text">
        {day}
      </span>

      <br />

      <span className="date-text">
        {formattedDate}
      </span>
    </div>
  );
};

export default WeekDayHeader;